export function filterShortFallLocations(locArray) {
  let shortFallLocations = []
  for(let item of locArray) {
    if(item['Shortfall Notification'] === 'true') {
      shortFallLocations.push({
        locationName: item['Location Name'],
        locationId: item['id']
      })
    }
  }
  return shortFallLocations
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataAgg/filterShortFallLocations.js